import { render, staticRenderFns } from "./ShortcodeSelectionDialog.vue?vue&type=template&id=e5c2a93a&scoped=true&"
import script from "./ShortcodeSelectionDialog.vue?vue&type=script&lang=js&"
export * from "./ShortcodeSelectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShortcodeSelectionDialog.vue?vue&type=style&index=0&id=e5c2a93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c2a93a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VForm,VRow})
